var _path, _rect, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLayer1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 70,
    viewBox: "0 0 45 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.62797 66.5592C4.916 66.9301 4.05585 66.4573 3.98736 65.6575L3.58557 60.9654C3.50891 60.0702 4.46094 59.4507 5.24837 59.8835L9.82674 62.4001C10.6142 62.8329 10.6015 63.9686 9.80456 64.3837L5.62797 66.5592Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35.7652,
    width: 9.42857,
    height: 68.3571,
    rx: 2.25,
    transform: "rotate(28.7957 35.7652 0)",
    fill: "#FFB484"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8639 1.70215L42.0562 3.45687C43.1452 4.05543 43.5428 5.42346 42.9442 6.51244L12.185 62.4732C11.5864 63.5622 10.2184 63.9597 9.12944 63.3612L9.03555 63.3096L38.8639 1.70215Z",
    fill: "#F29559"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer1);
export default __webpack_public_path__ + "static/media/Layer_1.8d81b7af8b4a1a05fcf19b72aec2052d.svg";
export { ForwardRef as ReactComponent };